import classNames from "classnames";
import { AnchorHTMLAttributes, PropsWithChildren } from "react";

type DropdownMenuItemLinkProps = {
  disabled?: boolean;
  "data-testid"?: string;
  className?: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export const DropdownMenuItemLink = ({
  children,
  className: additionalClasses,
  "data-testid": dataTestId,
  ...restProps
}: PropsWithChildren<DropdownMenuItemLinkProps>) => {
  return (
    <a
      data-testid={dataTestId ?? "dropdown-menu-item-link"}
      className={classNames(
        "no-underline",
        "rounded-sm",
        "cursor-pointer",
        "p-2",
        "m-2",
        "hover:bg-neutral-100",
        "focus:bg-neutral-100",
        "text-base",
        "text-text-base-primary",
        "block",
        "flex",
        additionalClasses
      )}
      {...restProps}
    >
      {children}
    </a>
  );
};
